import React, { useContext } from "react";
import { StyledDropdown } from "../dropdown/Dropdown.style";
import MenuItem from "../menu/MenuItem";
import Menu from "../menu/Menu";
import { DEFAULT_MENU_VISIBLE_ITEMS, InputContext } from "./Input";
import Box from "../box/Box";
import { highlightSuggestion } from "../menu/highlighting";
import useIdAttrs from "../../hooks/useIdAttrs";
import { apolloSpaceInset3X } from "@nexthink/apollo-tokens";
import { isAutoCompleteItem } from "./useInputAutocomplete";
export const suffixId = "-autocomplete";
const InputAutoCompleteDropdown = ({ id, "data-insights": insightsAttr, autoCompleteItems, onAutoCompleteSelect, autoCompleteVisibleItems = DEFAULT_MENU_VISIBLE_ITEMS, autoCompleteVirtualized = false, autoCompleteExtraTextMaxWidth = "50%", prefix, value, onChange, }) => {
    const [focusedIndex, setFocusedIndex] = useContext(InputContext);
    const idAttrs = useIdAttrs({ id, insightsAttr });
    const handleOnClick = (item) => (e) => {
        const itemValue = isAutoCompleteItem(item) ? item.value : item;
        setFocusedIndex(undefined);
        onChange(Object.assign(Object.assign({}, e), { target: Object.assign(Object.assign({}, e.target), { value: itemValue }), currentTarget: Object.assign(Object.assign({}, e.currentTarget), { value: itemValue }) })); // mimic change event
        onAutoCompleteSelect(item);
    };
    return (React.createElement(StyledDropdown, null,
        React.createElement(Menu, Object.assign({}, idAttrs(suffixId), { "aria-label": "input autocomplete", "aria-expanded": "true", variant: "select", size: "small" // always small independently of the input size
            , focusedIndex: focusedIndex, menuVisibleItems: autoCompleteVisibleItems, virtualized: autoCompleteVirtualized, drawFocusRingWithoutFocusing: true }), autoCompleteItems.map((item, index) => {
            const isAutoCompleteElement = isAutoCompleteItem(item);
            const itemValue = isAutoCompleteElement ? item.value : item;
            const extraText = isAutoCompleteElement ? item.extraText : undefined;
            return (React.createElement(MenuItem, Object.assign({ key: index }, idAttrs(`${suffixId}-${index}`), { onClick: handleOnClick(item), onMouseOver: () => {
                    setFocusedIndex(index);
                }, tabIndex: -1, extraText: extraText, extraTextMaxWidth: autoCompleteExtraTextMaxWidth }),
                React.createElement(Box, { ml: prefix ? apolloSpaceInset3X : undefined }, highlightSuggestion(itemValue, value))));
        }))));
};
export default InputAutoCompleteDropdown;
//# sourceMappingURL=InputAutoCompleteDropdown.js.map